import { MfaInterface } from '../../models/mfa.interface';

export interface MfaInterfaceState {
  result: MfaInterface|null;
}

export const initialMfaState: MfaInterfaceState = {
  result: null
};
